module.exports = __webpack_public_path__ + "img/event1029.793b2dd1.png";